import { useCallback } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { performDeleteRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';

const useDeleteIssueSecurity = (projectId: number, requestTypeExternalId: string) => {
	const request = useCallback(
		() =>
			performDeleteRequest(
				`/rest/servicedesk/1/project/${projectId}/request-type/${requestTypeExternalId}/issue-security`,
			),
		[projectId, requestTypeExternalId],
	);

	// Response body is empty so we don't need to return data.
	const { data, ...rest } = useService<undefined>(request);
	return rest;
};

export { useDeleteIssueSecurity };
